export enum EChecklistFileImportStep {
  DEAL_SELECT = "Deal Select",
  USER_SELECT = "User Select",
  FILE_UPLOAD = "File Upload",
  DETAILS = "Details",
  IMPORT_COMPLETED = "Import completed",
}

export enum EChecklistFileImportStatus {
  PENDING = "PENDING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
}
